import { BannerItem } from "./BannerItem";

export default BannerItem;
